const STORAGE_KEY = 'posHeldBills';

const safeParse = (value) => {
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

export const loadHeldBills = () => {
  if (typeof localStorage === 'undefined') return [];
  return safeParse(localStorage.getItem(STORAGE_KEY));
};

export const saveHeldBills = (bills) => {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(bills || []));
};

export const addHeldBill = (bill) => {
  const bills = loadHeldBills();
  bills.push(bill);
  saveHeldBills(bills);
  return bill;
};

export const removeHeldBill = (id) => {
  const bills = loadHeldBills().filter((b) => b.id !== id);
  saveHeldBills(bills);
  return bills;
};

export const getHeldBill = (id) => {
  return loadHeldBills().find((b) => b.id === id);
};

export const clearHeldBills = () => {
  saveHeldBills([]);
};
